import FormLabel from "./FormLabel";

const FormField = ({ label, children, required, description }) => {
  return (
    <div className="space-y-2">
      <FormLabel required={required}>{label}</FormLabel>
      {children}
      {description && (
        <p className="text-sm text-gray-500 leading-none">{description}</p>
      )}
    </div>
  );
};

export default FormField; 